export const ExpenseType = Object.freeze({
    NEED: 'need',
    WANT: 'want',
    INVESTMENT: 'investment'
});